import { render, staticRenderFns } from "./VendorForms.vue?vue&type=template&id=b30ca83a&scoped=true"
import script from "./VendorForms.vue?vue&type=script&lang=js"
export * from "./VendorForms.vue?vue&type=script&lang=js"
import style0 from "./VendorForms.vue?vue&type=style&index=0&id=b30ca83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30ca83a",
  null
  
)

export default component.exports